import { CommonModule } from '@angular/common';
import { Component, Type, computed, inject, input } from '@angular/core';

import { DynamicComponentDirective, MenuContentItem } from '@frontend/vanilla/core';

import { HeaderService } from '../header.service';

interface HeaderSectionItem {
    component$: Promise<Type<any> | null>;
    attr: { item: MenuContentItem };
    name: string;
}

@Component({
    imports: [CommonModule, DynamicComponentDirective],
    selector: 'vn-header-section',
    template: `
        @for (item of data(); track $index + item.name) {
            @if (item.component$ | async; as cmp) {
                <ng-container *vnDynamicComponent="cmp; attr: item.attr" />
            }
        }
    `,
})
export class HeaderSectionComponent {
    private readonly headerService = inject(HeaderService);

    readonly items = input<MenuContentItem[]>([]);

    readonly data = computed(() =>
        this.items().map(
            (item) =>
                ({
                    component$: this.headerService.getLazyComponentReactive(item.type),
                    attr: { item },
                    name: item.name,
                }) satisfies HeaderSectionItem,
        ),
    );
}
